import React from 'react';
import {Platform, View, StyleSheet} from 'react-native';
import {useStyles} from '../../../../../../../shared/hooks/styles';
import {useAccountLinker} from '../../../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';
import {Modal} from '../../../../../../../shared/components/modal/modal';
import {useTheme} from '../../../../../../../shared/theme';
import {DeviceSize} from '../../../../../../../shared/theme/helpers';
import {Button} from '../../../../../../../shared/components/button';

type Props = {
  id: number;
  onClose: () => void;
};

function UnlinkConfirmation(props: Props) {
  const {id, onClose} = props;
  const {declineLinkRequest} = useAccountLinker();
  const theme = useTheme();
  const styles = useStyles(({mediaOnly, mediaExclude}) => {
    return {
      innerButton: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: theme.color.primaryColor,
      },
      textInnerContainer: theme.fonts.bodySmall,
      container: StyleSheet.flatten([
        {
          height: 150,
          flexGrow: 1,
          flexShrink: 0,
        },
        mediaOnly(
          DeviceSize.desktop,
          {width: 300, marginTop: 24},
          {width: Platform.OS === 'web' ? 260 : 284, paddingTop: 18},
        ),
      ]),
      fieldContainer: {
        marginBottom: 10,
        ...mediaExclude(DeviceSize.desktop, {marginTop: 5}),
      },
      buttonWrapper: {
        marginTop: 10,
      },
      buttonYes: StyleSheet.flatten([
        {
          alignSelf: 'center',
          marginTop: 'auto',
          marginBottom: 0,
        },
        mediaOnly(DeviceSize.desktop, {width: 300}, {width: '100%'}),
      ]),
      buttonNo: StyleSheet.flatten([
        {
          alignSelf: 'center',
          marginTop: 20,
          marginBottom: 0,
        },
        mediaOnly(DeviceSize.desktop, {width: 300}, {width: '100%'}),
      ]),
    };
  });

  const handlePressConfirmationUnlinking = () => {
    onClose();
    declineLinkRequest(id.toString());
  };

  const handlePressRefusalUnlinking = () => {
    onClose();
  };

  return (
    <View style={styles.container}>
      <View style={styles.buttonWrapper}>
        <Button
          id='login-enter-next'
          type='secondary'
          style={styles.buttonYes}
          onPress={handlePressConfirmationUnlinking}
          iconProps={{width: 16, height: 19}}
          text='Да'
        />
        <Button
          id='login-enter-next'
          type='secondary'
          style={styles.buttonNo}
          onPress={handlePressRefusalUnlinking}
          iconProps={{width: 16, height: 19}}
          text='Нет'
        />
      </View>
    </View>
  );
}

type PropsModal = {
  fullName: string;
  id: number;
  onClose: () => void;
};

export function UnlinkConfirmationModal(props: PropsModal) {
  const {id, onClose, fullName} = props;
  const styles = useStyles(({theme}) => ({
    modalTitle: {
      paddingTop: 50,
      ...theme.fonts.h3,
    },
    modalWrap: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingHorizontal: 0,
      overflow: 'hidden',
      width: '30%',
      margin: Platform.OS === 'ios' ? 1 : 0,
    },
    contentStyle: {
      paddingTop: 0,
      display: 'flex',
      alignItems: 'center',
    },
  }));

  const title = `Вы уверены, что хотите отвязать учетную запись ${fullName}?`;

  return (
    <Modal
      title={title}
      onClose={onClose}
      titleStyle={styles.modalTitle}
      wrapStyle={styles.modalWrap}
      contentStyle={styles.contentStyle}>
      <UnlinkConfirmation id={id} onClose={onClose} />
    </Modal>
  );
}
